import React from 'react';
import { View, ScrollView, TouchableOpacity } from 'react-native';
import { Text } from '@/components';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import privacyStyles from './privacy.styles';
import { ArrowLeft } from 'lucide-react-native';
import { useRouter } from 'expo-router';
import theme from '@/constants/colors';
import { useTranslation } from 'react-i18next';

export default function PrivacyScreen() {
	const insets = useSafeAreaInsets();
	const router = useRouter();
	const { t } = useTranslation();

	return (
		<View style={[privacyStyles.container, { paddingTop: insets.top + 16, paddingLeft: 16, paddingRight: 16 }]}> 
			<View style={privacyStyles.header}>
				<TouchableOpacity style={privacyStyles.backButton} onPress={() => router.push('/settings')}>
					<ArrowLeft size={20} color={theme.accentPrimary} />
				</TouchableOpacity>
				<View style={{ width: 40 }} />
			</View>
			<ScrollView contentContainerStyle={privacyStyles.content}>
				<Text style={privacyStyles.title}>{t('privacy.title')}</Text>
				<Text style={privacyStyles.updated}>{t('privacy.lastUpdated')}</Text>

				<Text style={privacyStyles.paragraph}>
					{t('privacy.intro')}
				</Text>

				<Text style={privacyStyles.heading}>{t('privacy.whoWeAre')}</Text>
				<Text style={privacyStyles.paragraph}>
					{t('privacy.whoWeAreText')}{" "}
					<Text style={privacyStyles.link}>contact@tailtrails.club</Text>.
				</Text>

				<Text style={privacyStyles.heading}>{t('privacy.whatDataWeCollect')}</Text>
				<Text style={privacyStyles.paragraph}>
					{t('privacy.whatDataWeCollectText')}
				</Text>
				<View style={privacyStyles.list}>
					<Text style={privacyStyles.listItem}>{t('privacy.dataNameEmail')}</Text>
					<Text style={privacyStyles.listItem}>{t('privacy.dataLocation')}</Text>
					<Text style={privacyStyles.listItem}>{t('privacy.dataDogProfile')}</Text>
					<Text style={privacyStyles.listItem}>{t('privacy.dataPhotos')}</Text>
				</View>

				<Text style={privacyStyles.heading}>{t('privacy.whyWeCollect')}</Text>
				<View style={privacyStyles.list}>
					<Text style={privacyStyles.listItem}>{t('privacy.whyContractual')}</Text>
					<Text style={privacyStyles.listItem}>{t('privacy.whyConsent')}</Text>
				</View>

				<Text style={privacyStyles.heading}>{t('privacy.thirdParties')}</Text>
				<Text style={privacyStyles.paragraph}>{t('privacy.thirdPartiesText')}</Text>

				<Text style={privacyStyles.heading}>{t('privacy.whereDataStored')}</Text>
				<Text style={privacyStyles.paragraph}>{t('privacy.whereDataStoredText')}</Text>

				<Text style={privacyStyles.heading}>{t('privacy.howLongKeep')}</Text>
				<Text style={privacyStyles.paragraph}>{t('privacy.howLongKeepText')}</Text>

				<Text style={privacyStyles.heading}>{t('privacy.yourRights')}</Text>
				<Text style={privacyStyles.paragraph}>{t('privacy.yourRightsText')}</Text>
				<View style={privacyStyles.list}>
					<Text style={privacyStyles.listItem}>{t('privacy.rightAccess')}</Text>
					<Text style={privacyStyles.listItem}>{t('privacy.rightDelete')}</Text>
					<Text style={privacyStyles.listItem}>{t('privacy.rightPortability')}</Text>
					<Text style={privacyStyles.listItem}>{t('privacy.rightWithdrawConsent')}</Text>
				</View>

				<Text style={privacyStyles.paragraph}>{t('privacy.contactUs')}{" "}<Text style={privacyStyles.link}>contact@tailtrails.club</Text>.</Text>

				<Text style={privacyStyles.heading}>{t('privacy.changesToPolicy')}</Text>
				<Text style={privacyStyles.paragraph}>{t('privacy.changesToPolicyText')}</Text>
			</ScrollView>
		</View>
	);
}